<script>
  import { Button } from "../../Components";
  import { CFA } from "../../Components/Icons";
  export let enable = true;

  export let intro = "Für den Besuch der Vorträge der Starreferenten erhalten Sie CFA Continued Education Points.";
  export let description =
    "Die CFA Society Germany und CFA Society Austria haben festgelegt, dass die mit {logo} gekennzeichneten Vorträge den Guidelines des CFA Institute Continuing Education Programs entsprechen. CFA Institute Members erhalten bis zu 3 CE Credits pro Tag bzw. abhängig von ihrer Anwesenheit den entsprechenden aliquoten Anteil. Lassen Sie sich daher bitte in der Lounge der CFA Society sowohl beim Zutritt zum Kongress als auch beim Verlassen registrieren. So kann Ihre Anwesenheit erfasst werden, und es wird Ihnen die entsprechende Anzahl von Credits zugeteilt. CFA Institute Members werden CE Credit Hours für ihre Teilnahme automatisch im CE Tracking Tool gutgeschrieben.";
  let showDetail = false;
</script>

{#if enable}
  <div class="prose flex max-w-none items-center gap-2">
    <figure class="m-0">
      <CFA class="w-20" />
    </figure>
    <p class="m-0">{intro}</p>
  </div>

  {#if description}
    <div class="prose mt-4 max-w-none">
      {#if showDetail}
        <p>
          <CFA class="m-0 inline-block w-20" {description} />
        </p>
      {:else}
        <div class="flex justify-center">
          <Button
            ghost
            on:click={() => {
              showDetail = true;
            }}
          >
            mehr erfahren
          </Button>
        </div>
      {/if}
    </div>
  {/if}
{/if}
